// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterSocials_root__ztEq3","image":"FooterSocials_image__2FhME"};